import webGL from './webGL'

const perlin = {
	init() {
		this.p = new Uint8Array(512);
		const p = new Uint8Array(256);
		for (let i = 0; i < 256; i++) p[i] = i;
		for (let i = 255; i > 0; i--) {
			const n = Math.floor((i + 1) * Math.random());
			[p[i], p[n]] = [p[n], p[i]];
		}
		for (let i = 0; i < 512; i++) this.p[i] = p[i & 255];
	},
	fade(t) {
		return t * t * t * (t * (t * 6 - 15) + 10);
	},
	lerp(t, a, b) {
		return a + t * (b - a);
	},
	grad(hash, x, y, z) {
		const h = hash & 15;
		const u = h < 8 ? x : y;
		const v = h < 4 ? y : h == 12 || h == 14 ? x : z;
		return ((h & 1) == 0 ? u : -u) + ((h & 2) == 0 ? v : -v);
	},
	noise(xi, yi, zi) {
		const X = Math.floor(xi) & 255;
		const Y = Math.floor(yi) & 255;
		const Z = Math.floor(zi) & 255;
		const x = xi - Math.floor(xi);
		const y = yi - Math.floor(yi);
		const z = zi - Math.floor(zi);
		const u = this.fade(x);
		const v = this.fade(y);
		const w = this.fade(z);
		const A = this.p[X] + Y;
		const AA = this.p[A] + Z;
		const AB = this.p[A + 1] + Z;
		const B = this.p[X + 1] + Y;
		const BA = this.p[B] + Z;
		const BB = this.p[B + 1] + Z;
		return this.lerp(
			w,
			this.lerp(
				v,
				this.lerp(u, this.grad(this.p[AA], x, y, z), this.grad(this.p[BA], x - 1, y, z)),
				this.lerp(u, this.grad(this.p[AB], x, y - 1, z), this.grad(this.p[BB], x - 1, y - 1, z))
			),
			this.lerp(
				v,
				this.lerp(u, this.grad(this.p[AA + 1], x, y, z - 1), this.grad(this.p[BA + 1], x - 1, y, z - 1)),
				this.lerp(
					u,
					this.grad(this.p[AB + 1], x, y - 1, z - 1),
					this.grad(this.p[BB + 1], x - 1, y - 1, z - 1)
				)
			)
		);
	}
};


let z = 0;
function run(canvas) {

	const sw = canvas.width / 100;
	const sh = Math.min(15,sw) * 25;

	canvas.clear();

	for (let i = 0; i < 180; i++) {
		canvas.beginPath();
		canvas.strokeStyle(
			z + i / 360,
			0.25,
			0.1
		);
		for (let j = -50; j < 50; j++) {
			const h = perlin.noise(j * 0.05, z - i * 0.01, z);
			canvas.lineTo(
				canvas.width * 0.5 + 0.01 * (i + 180) * j * sw * 0.5,
				// -90 + i + canvas.height * 0.5 + h * sh
				-90 + i + Math.min(300,canvas.height) * 0.5 + h * sh
			);
		}
		canvas.stroke();
	}

	z += 0.0025;
	requestAnimationFrame(()=>run(canvas));
}

const wave = {
	init: function(ele,options){
		const canvas = webGL.init(ele,{
			// alpha: true,
			// stencil: false,
			// antialias: false,
			// depth: false,
		});
		canvas.blend(canvas.gl.ONE, canvas.gl.ONE);
		perlin.init();
		canvas.createBufferLine(100);
		return canvas
	},
	run
}

export default wave;



// WEBPACK FOOTER //
// ./src/TopWave.js